module.exports = __webpack_public_path__ + "static/mstile-150x150-7016f1c19daee85dae774ee3947f2edf.png";